'use client'

import { Spacer } from '@vinted/web-ui'

import { ReferralsBanner } from '@marketplace-web/domain/banners'
import { ProfileTaxpayerBanner } from '@marketplace-web/domain/taxpayers'

import { ProfileBadges } from '@marketplace-web/domain/seller-engagement-tools'
import { ProductItemModel } from '@marketplace-web/domain/product-item-data'
import { ProfileVasBanners } from '@marketplace-web/domain/vas'

import { useBreakpoint } from '@marketplace-web/shared/breakpoints'
import { useAbTest } from '@marketplace-web/shared/ab-tests'

type Props = {
  renderCountDownBanner: () => JSX.Element | null
  getSingleBumpableItem: () => ProductItemModel | undefined
}

const ProfileOwnerBanners = ({ renderCountDownBanner, getSingleBumpableItem }: Props) => {
  const breakpoints = useBreakpoint()

  const profileReworkAbTest = useAbTest('profile_wardrobe_web_rework')
  const isProfileReworkTestOn = profileReworkAbTest?.variant === 'on' && !breakpoints.portables

  return (
    <>
      {(!isProfileReworkTestOn || breakpoints.phones) && <ProfileTaxpayerBanner />}
      <ReferralsBanner
        bottomSpacer={breakpoints.tabletsUp && <Spacer size={Spacer.Size.XLarge} />}
      />
      {renderCountDownBanner()}
      <ProfileVasBanners getSingleBumpableItem={getSingleBumpableItem} />
      {(!isProfileReworkTestOn || breakpoints.phones) && <ProfileBadges />}
    </>
  )
}

export default ProfileOwnerBanners
